import React, { useEffect } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaTimes } from 'react-icons/fa';
import './Snackbar.css';

const Snackbar = ({
    isOpen,
    message,
    type = 'success', // 'success' | 'error' | 'info'
    duration = 5000,
    onClose
}) => {

    useEffect(() => {
        if (isOpen && duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [isOpen, duration, onClose]);

    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <FaCheckCircle className="snackbar-icon" />;
            case 'error':
                return <FaExclamationCircle className="snackbar-icon" />;
            default:
                return <FaCheckCircle className="snackbar-icon" />;
        }
    };

    return (
        <div className={`snackbar snackbar-${type} ${isOpen ? 'snackbar-open' : ''}`}>
            <div className="snackbar-content">
                {getIcon()}
                <span className="snackbar-message">{message}</span>
            </div>
            <button
                className="snackbar-close"
                onClick={onClose}
                aria-label="Закрыть"
            >
                <FaTimes />
            </button>
        </div>
    );
};

export default Snackbar;
